import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import Button from '@mlb/react-patterns/components/Button/button.tsx';

import { getIsTouchDevice } from 'bdvp-common/src/utils';
import { useDictionary } from 'bdvp-common/src/hooks/config';
import { Tracking } from 'bdvp-tracking';

const SearchButton = (props) => {

    const {
        isActive,
        onClick,
        className,
    } = props;

    const { search_text = 'Search' } = useDictionary();

    const [
        isClient,
        setIsClient,
    ] = useState(false);

    useEffect(() => {

        setIsClient(true);

    }, []);

    const isTouchDevice = isClient && getIsTouchDevice();

    return (
        <Button
            active={isActive}
            disabled={!isClient}
            handlers={{
                onClick: () => {

                    Tracking.trackSearchButtonClick();
                    onClick();

                },
            }}
            iconName={'search'}
            label={search_text}
            shape={'hollow-borderless'}
            size={'lg'}
            styleName={'default'}
            hasHover={!isTouchDevice}
            className={className}
        />
    );

};

SearchButton.propTypes = {
    isActive: PropTypes.bool,
    onClick: PropTypes.func.isRequired,
    className: PropTypes.string,
};

SearchButton.defaultProps = {
    isActive: false,
    className: '',
};

export default SearchButton;
